module.exports = __webpack_public_path__ + "static/03-22a07601bb216587a76ac5d4354a5aec.jpg";